import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dir"]

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/src/jquery.js';
import 'bootstrap/dist/js/bootstrap.min.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faDiscord,
  faPatreon,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

import { useStore } from 'vuex';
import { useRTL } from '@/composables/useRTL';

import Map from '@/components/Map.vue';
import Sidebar from '@/components/Sidebar.vue';
import modal from '@/components/Modal.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const store = useStore();
const rtl = useRTL();

library.add(faPatreon);
library.add(faXTwitter);
library.add(faDiscord);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home", { 'dark-mode': _unref(store).state.dark }]),
    dir: _unref(rtl) ? 'rtl' : 'ltr'
  }, [
    _createVNode(modal),
    _createVNode(Map),
    _createVNode(Sidebar)
  ], 10, _hoisted_1))
}
}

})